import React, {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {PopUpWrapper, PopUpContent, PopupOuter} from './styles';
import {BTag} from 'core/components';
import {API, Tag, TagsAPI} from '@brg/api';
import {useTranslation} from 'react-i18next';
import {bTag} from 'core';
import {CreateLinkTo} from 'shared/constants/linkTo';
import {useHistory} from 'react-router-dom';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {Link} from "../link";
import {AppTester} from "../../../supporting";
import {ThemeProvider} from "styled-components";
import {ApplicationTheme} from "../../themes";
import { useTags } from 'shared/hooks/api/useTagsList';

export type TagsCoor = {
    x: number | null,
    y: number | null
}

const FULL_SIZE_POPUP_CONDITION = 3;

export const TagsPopUp: FC<{
    list: any,
    currentTab: string | null;
    visible?: boolean;
    coor?: TagsCoor;
    blueSelect?: boolean;
    onTagClick?: (tagId: string) => void;
    onMouseEnter?: () => void;
}> = ({
          list,
          currentTab,
          visible,
          coor,
          blueSelect,
          onTagClick,
          onMouseEnter,
      }) => {
    const {i18n} = useTranslation();
    const prevRef = useRef<any>(null);
    const history = useHistory();
    const [tags, setTags] = useState<Tag[]>([]);
    const [tagsForTab, setTagsForTab] = useState<string | null>(null);
    const [time, setTime] = useState(Date.now());

    const hasCoor = useMemo(() => (coor?.x !== null && coor?.y !== null), [coor])

    const idsList = useMemo(() => {
        if (!!list?.length && hasCoor && currentTab) {
            if (currentTab === 'all') {
                const allTags = list?.reduce((acc: string[], item: any) => {
                    Object.keys(item).forEach(key => {
                        if (key !== 'all' && Array.isArray(item[key])) {
                            acc.push(...item[key]);
                        }
                    });
                    return acc;
                }, []);
                return allTags;
            }
            
            const result = list?.filter((i: any) => {
                if (!i[currentTab]?.includes('geo_all')) {
                    return i[currentTab]
                }
            })[0]?.[currentTab];

            return result;
        }
        return undefined;
    }, [list, currentTab, hasCoor])

    const [tagsData] = useTags({ tagIds: idsList}, i18n.language, time, !idsList?.length, true)

    useEffect(() => {
        if (tagsData?.length && currentTab) {
            setTags(tagsData?.sort((a,b) => {
                return a.isEducationTag === true ? -1 : b.isEducationTag === true ? 1 : 0;
            }))
            setTagsForTab(currentTab);
        }
    }, [tagsData, currentTab])

    useEffect(() => {
        if (currentTab && idsList) {
            setTime(Date.now())
        }
    }, [idsList, currentTab])

    const showPopUp = useMemo(() => (visible && (!!idsList && idsList?.length )&& !!list?.length), [visible, idsList, list])

    const fs = useMemo(() => (!!tags?.length && tags?.length >= FULL_SIZE_POPUP_CONDITION), [tags]);

    const clear = useCallback(() => {
        setTags([]);
        setTagsForTab(null);
    }, []);

    useEffect(() => {
        if (currentTab !== prevRef.current) {
            if (currentTab === null) {
                clear()
            }
        }
        prevRef.current = currentTab
    }, [currentTab, clear])

    const isBooksGallllery = AppTester.isBooksGallllery();

    const shouldRender = currentTab !== 'all' && showPopUp;
    const isVisible = showPopUp && tags?.length > 0 && tagsForTab === currentTab;
    
    const popupContent = !shouldRender ? null : (
        <PopUpWrapper
            key={currentTab}
            className={'tags-popup-wrapper'}
            positionY={coor?.y}
            positionX={coor?.x}
            visible={isVisible}
            fs={fs}
            blueSelect={blueSelect}
            onMouseEnter={onMouseEnter}
        >
            {tags?.length > 0 && (
                <PopupOuter>
                    <PopUpContent>
                        <BTagsGridNew>
                            {tags && tags.map((value: any) => (
                                <Link 
                                    key={value.tagId}
                                    to={CreateLinkTo.tag(value?.tagId)} 
                                    title={bTag.title(value)} 
                                    type="tag"
                                    target="_blank"
                                >
                                    <BTag
                                        tag={value}
                                        educational={value.isEducationTag}
                                        organization={value.isTeamTag}
                                        isInfoTags
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                </Link>
                            ))}
                        </BTagsGridNew>
                    </PopUpContent>
                </PopupOuter>
            )}
        </PopUpWrapper>
    );

    if (isBooksGallllery) {
        return (
            <ThemeProvider theme={ApplicationTheme.white}>
                {popupContent}
            </ThemeProvider>
        );
    }

    return popupContent;
}import React, {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {PopUpWrapper, PopUpContent, PopupOuter} from './styles';
import {BTag} from 'core/components';
import {API, Tag, TagsAPI} from '@brg/api';
import {useTranslation} from 'react-i18next';
import {bTag} from 'core';
import {CreateLinkTo} from 'shared/constants/linkTo';
import {useHistory} from 'react-router-dom';
import {BTagsGridNew} from "../../../core/components/bTag/bTagsGridNew/bTagsGridNew";
import {Link} from "../link";
import {AppTester} from "../../../supporting";
import {ThemeProvider} from "styled-components";
import {ApplicationTheme} from "../../themes";
import { useTags } from 'shared/hooks/api/useTagsList';

export type TagsCoor = {
    x: number | null,
    y: number | null
}

const FULL_SIZE_POPUP_CONDITION = 3;

export const TagsPopUp: FC<{
    list: any,
    currentTab: string | null;
    visible?: boolean;
    coor?: TagsCoor;
    blueSelect?: boolean;
    onTagClick?: (tagId: string) => void;
    onMouseEnter?: () => void;
}> = ({
          list,
          currentTab,
          visible,
          coor,
          blueSelect,
          onTagClick,
          onMouseEnter,
      }) => {
    const {i18n} = useTranslation();
    const prevRef = useRef<any>(null);
    const history = useHistory();
    const [tags, setTags] = useState<Tag[]>([]);
    const [tagsForTab, setTagsForTab] = useState<string | null>(null);
    const [time, setTime] = useState(Date.now());

    const hasCoor = useMemo(() => (coor?.x !== null && coor?.y !== null), [coor])

    const idsList = useMemo(() => {
        if (!!list?.length && hasCoor && currentTab) {
            if (currentTab === 'all') {
                const allTags = list?.reduce((acc: string[], item: any) => {
                    Object.keys(item).forEach(key => {
                        if (key !== 'all' && Array.isArray(item[key])) {
                            acc.push(...item[key]);
                        }
                    });
                    return acc;
                }, []);
                return allTags;
            }
            
            const result = list?.filter((i: any) => {
                if (!i[currentTab]?.includes('geo_all')) {
                    return i[currentTab]
                }
            })[0]?.[currentTab];

            return result;
        }
        return undefined;
    }, [list, currentTab, hasCoor])

    const [tagsData] = useTags({ tagIds: idsList}, i18n.language, time, !idsList?.length, true)

    useEffect(() => {
        if (tagsData?.length && currentTab) {
            setTags(tagsData?.sort((a,b) => {
                return a.isEducationTag === true ? -1 : b.isEducationTag === true ? 1 : 0;
            }))
            setTagsForTab(currentTab);
        }
    }, [tagsData, currentTab])

    useEffect(() => {
        if (currentTab && idsList) {
            setTime(Date.now())
        }
    }, [idsList, currentTab])

    const showPopUp = useMemo(() => (visible && (!!idsList && idsList?.length )&& !!list?.length), [visible, idsList, list])

    const fs = useMemo(() => (!!tags?.length && tags?.length >= FULL_SIZE_POPUP_CONDITION), [tags]);

    const clear = useCallback(() => {
        setTags([]);
        setTagsForTab(null);
    }, []);

    useEffect(() => {
        if (currentTab !== prevRef.current) {
            if (currentTab === null) {
                clear()
            }
        }
        prevRef.current = currentTab
    }, [currentTab, clear])

    const isBooksGallllery = AppTester.isBooksGallllery();

    const shouldRender = currentTab !== 'all' && showPopUp;
    const isVisible = showPopUp && tags?.length > 0 && tagsForTab === currentTab;
    
    const popupContent = !shouldRender ? null : (
        <PopUpWrapper
            key={currentTab}
            className={'tags-popup-wrapper'}
            positionY={coor?.y}
            positionX={coor?.x}
            visible={isVisible}
            fs={fs}
            blueSelect={blueSelect}
            onMouseEnter={onMouseEnter}
        >
            {tags?.length > 0 && (
                <PopupOuter>
                    <PopUpContent>
                        <BTagsGridNew>
                            {tags && tags.map((value: any) => (
                                <Link 
                                    key={value.tagId}
                                    to={CreateLinkTo.tag(value?.tagId)} 
                                    title={bTag.title(value)} 
                                    type="tag"
                                    target="_blank"
                                >
                                    <BTag
                                        tag={value}
                                        educational={value.isEducationTag}
                                        organization={value.isTeamTag}
                                        isInfoTags
                                    >
                                        {bTag.title(value)}
                                    </BTag>
                                </Link>
                            ))}
                        </BTagsGridNew>
                    </PopUpContent>
                </PopupOuter>
            )}
        </PopUpWrapper>
    );

    if (isBooksGallllery) {
        return (
            <ThemeProvider theme={ApplicationTheme.white}>
                {popupContent}
            </ThemeProvider>
        );
    }

    return popupContent;
}